import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import { DataService } from "../bpg-common/services/data.services";

import { EnvironmentConfiguration } from '../environment/services/environment.configuration';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginDto: any;
  userMasterDTO: any;
  userId = '';
  passwordId = '';
  activeClass = "login_success";
  userIdDto: any;
  loginData = [];
  landingDto: any;
  loginDatas: string;
  userRoleDetails: any;
  bpgName: string;
  siteBpgList = [];
  landingData: any;

  constructor(private readonly route: Router, private readonly bpgCommonService: BpgCommonService, private readonly data: DataService,  private readonly environment: EnvironmentConfiguration) { }


  ngOnInit() {
    this.landingDto = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    if (this.environment.envName === 'local' || this.environment.envName === 'staging') {
      localStorage.setItem('userManagementUrl', this.environment.apiBaseUrl + '7000');
      localStorage.setItem('eventManagementUrl', this.environment.apiBaseUrl + '7001');
      localStorage.setItem('financialManagementUrl', this.environment.apiBaseUrl + '7002');
    } 
    
    else if(this.environment.envName === 'qa' )
    {
      localStorage.setItem('userManagementUrl', this.environment.apiBaseUrl + '7000');
      localStorage.setItem('eventManagementUrl', this.environment.eventapiBaseUrl + '7001');
      localStorage.setItem('financialManagementUrl', this.environment.financeapiBaseUrl + '7002');
    }
    else if(this.environment.envName === 'prod' )
    {
      localStorage.setItem('userManagementUrl', this.environment.apiBaseUrl);
      localStorage.setItem('eventManagementUrl', this.environment.eventapiBaseUrl);
      localStorage.setItem('financialManagementUrl', this.environment.financeapiBaseUrl);
    }
    else  if(this.environment.envName === 'dev') {
      localStorage.setItem('userManagementUrl', this.environment.apiBaseUrl);
      localStorage.setItem('eventManagementUrl', this.environment.apiBaseUrl);
      localStorage.setItem('financialManagementUrl', this.environment.apiBaseUrl);
    }
  }

  login() {

    this.loginDto = {
      "username": this.userId,
      "password": this.passwordId
    }

    this.bpgCommonService.login(this.loginDto).subscribe(data => {

      this.bpgCommonService.loginMonitor(this.loginDto).subscribe(_data => {
     })

      if (data.workdayId != null) {
        this.activeClass = "login_success";
        this.loginData = data;
        localStorage.setItem('loginData', JSON.stringify(this.loginData));

        this.loginDatas = JSON.parse(localStorage.getItem('loginData'));

        this.userIdDto = { "userId": this.loginDatas['userId'] };

        this.bpgCommonService.getUserRoleDetails(this.userIdDto).subscribe(data => {

          this.userRoleDetails = data;
          localStorage.setItem('userSiteId', this.loginData['site']['siteId']);
          localStorage.setItem('selectedSiteId', this.loginData['site']['siteId']);
          localStorage.setItem('adminId', this.userRoleDetails['adminId']);
          localStorage.setItem('leadAdminId', this.userRoleDetails['leadAdminId']);

          this.route.navigate(['/di-home']);
        })

      } else {
        this.activeClass = "login_failed";
      }
    })
    return null;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }







}




